module.exports = __webpack_public_path__ + "static/media/WS.30dcaf20.png";